import React from "react";
import { motion } from "framer-motion";
import { BookOpen, Headphones, PlayCircle } from "lucide-react";
import { useLanguage } from "../i18n";

export default function Sermons() {
  const { t } = useLanguage();
  const sermons = t("sermons.sermons", []);

  return (
    <div className="font-sans-clean min-h-screen bg-[#FDF8F3]">
      <section className="relative py-20 sm:py-24 overflow-hidden bg-[#5b2229]">
        <div className="absolute inset-0 opacity-20 ethiopian-cross" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl">
            <h1 className="font-serif-elegant text-4xl sm:text-5xl font-bold text-white mb-4">
              {t("sermons.title")}
            </h1>
            <p className="text-white/80 text-lg">{t("sermons.intro")}</p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-3xl p-8 border border-[#C9A227]/10 shadow-sm mb-8">
          <h2 className="font-serif-elegant text-2xl font-bold text-[#722F37] mb-3">
            {t("sermons.archiveTitle")}
          </h2>
          <p className="text-gray-700 max-w-3xl">{t("sermons.archiveBody")}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {sermons.map((sermon, index) => (
            <motion.div
              key={`${sermon.title}-${sermon.dateLabel}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="bg-white rounded-3xl shadow-sm border border-[#C9A227]/10 overflow-hidden flex flex-col"
            >
              <div className="w-full h-40 bg-[#722F37] flex items-center justify-center">
                <BookOpen className="w-10 h-10 text-[#C9A227]" />
              </div>

              <div className="p-6 flex flex-col gap-3 flex-1">
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-[0.16em]">
                    {sermon.dateLabel}
                  </p>
                  <h2 className="font-serif-elegant text-xl font-bold text-[#722F37]">
                    {sermon.title}
                  </h2>
                  {sermon.speaker && (
                    <p className="text-sm text-gray-600">
                      {t("sermons.by")} {sermon.speaker}
                    </p>
                  )}
                </div>

                {sermon.summary && <p className="text-sm text-gray-600">{sermon.summary}</p>}

                {sermon.scripture && (
                  <p className="text-xs text-[#C9A227] mt-auto">
                    {t("sermons.scripture")}: {sermon.scripture}
                  </p>
                )}

                <div className="flex gap-3 mt-3">
                  <div className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-[#722F37]/10 text-[#722F37] text-sm">
                    <Headphones className="w-4 h-4" />
                    {t("sermons.audioSoon")}
                  </div>
                  <div className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-[#722F37]/20 text-[#722F37] text-sm">
                    <PlayCircle className="w-4 h-4" />
                    {t("sermons.videoSoon")}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
